import { render } from "./Satelital.view.vue?vue&type=template&id=5bcacfa2&scoped=true&ts=true"
import script from "./Satelital.view.vue?vue&type=script&lang=ts"
export * from "./Satelital.view.vue?vue&type=script&lang=ts"

import "./Satelital.view.vue?vue&type=style&index=0&id=5bcacfa2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcacfa2"]])

export default __exports__